import React, { useState } from 'react';

import Footer from './components/Footer'
import Navbar from './components/Navbar'
import NavRoutes from './components/NavRoutes'

const App = () => {
  const [darkTheme, setDarkTheme] = useState(false);

  return (
    <div className={darkTheme ? 'dark' : ''}>
      <div className="dark:bg-gray-900 bg-gray-100 dark:text-gray-200 black min-h-screen">
        <Navbar darkTheme={darkTheme} setDarkTheme={setDarkTheme} />
        <NavRoutes />
        <Footer />
      </div>
    </div>

  );
};

export default App;